import React from 'react';
import * as S from './timeline-segment.styles';

interface ITimelineSegmentProps {
    end?: boolean;
    start?: boolean;
    selected?: boolean;
}

const padding = 0;
const width = 20;
const height = 40;
export const TimelineSegment: React.FC<ITimelineSegmentProps> = (props: ITimelineSegmentProps) => {
    const { end, start, selected } = props;
    const x = width / 2;

    const isStart = start && !end;
    const isMiddle = !start && !end;
    const isEnd = end && !start;
    return (
        <S.Wrapper>
            <S.ScaledSvg height="100%" width={width} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
                {(isStart || isMiddle) && (
                    <S.FgLine className="fg" x1={x} y1={0} x2={x} y2={height} selected={selected} />
                )}
                {!isStart && !isMiddle && <S.BgLine className="bg" x1={x} y1={0} x2={x} y2={height} />}
            </S.ScaledSvg>
            <S.FixedSvg height="100%" width={width} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMin">
                {isEnd && <S.FgLine className="fg" x1={x} y1={0} x2={x} y2={height / 2} selected={selected} />}
                {isStart && <S.BgLine className="bg" x1={x} y1={0} x2={x} y2={height / 2} />}
                {!isEnd || (!isStart && <S.NoLine x1={x} y1={height / 2} x2={x} y2={height} />)}
                {!isEnd && !isMiddle && (
                    <S.Dot className="dot" cx={width / 2} cy={height / 2 + padding} r={4} selected={selected} />
                )}
                {isEnd && (
                    <S.OpenDot className="open" cx={width / 2} cy={height / 2 + padding} r={4} selected={selected} />
                )}
            </S.FixedSvg>
        </S.Wrapper>
    );
};
